export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/gukhwa-jangs-9f284dcf57f081e5763510377e71f8d6.jpg";